const DataTabIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 26 26"
    >
      <g clipPath="url(#a)">
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.048"
          d="M4.193 6.29c0 .833.884 1.633 2.456 2.223 1.573.59 3.706.921 5.93.921 2.224 0 4.357-.331 5.93-.92 1.573-.59 2.456-1.39 2.456-2.225 0-.834-.883-1.634-2.456-2.223-1.573-.59-3.706-.921-5.93-.921-2.224 0-4.357.33-5.93.92-1.572.59-2.456 1.39-2.456 2.224Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.048"
          d="M4.193 6.29v6.289c0 .834.884 1.634 2.456 2.223 1.573.59 3.706.921 5.93.921 2.224 0 4.357-.33 5.93-.92 1.573-.59 2.456-1.39 2.456-2.224v-6.29"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.048"
          d="M4.193 12.58v6.289c0 .834.884 1.634 2.456 2.223 1.573.59 3.706.922 5.93.922 2.224 0 4.357-.332 5.93-.922 1.573-.59 2.456-1.39 2.456-2.223v-6.29"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h25.158v25.158H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DataTabIcon;
